// extracted by mini-css-extract-plugin
export var background = "Global-module--background--d9232";
export var backgroundImage = "Global-module--backgroundImage--1923d";
export var content = "Global-module--content--c1bec";
export var global = "Global-module--global--d7f6a";
export var heading = "Global-module--heading--766b4";
export var heading2 = "Global-module--heading2--5e4c1";
export var overlay = "Global-module--overlay--ff842";
export var paragraph = "Global-module--paragraph--4c5b8";
export var textWrapper = "Global-module--textWrapper--8ad95";